const DAY_MS = 1000 * 3600 * 24
const EXPIRING_WITHIN_DAYS = 30

export const CONNECTION_STATUS = {
    ACTIVE: 'active',
    EXPIRING: 'expiring',
    EXPIRED: 'expired'
}

export const daysUntilExpiry = (connection, now = new Date()) => Math.round((new Date(connection.expiryDate) - now) / DAY_MS)

export const connectionStatus = (connection) => {
    const days = daysUntilExpiry(connection)
    if (days < 1) return CONNECTION_STATUS.EXPIRED
    if (days <= EXPIRING_WITHIN_DAYS) return CONNECTION_STATUS.EXPIRING
    return CONNECTION_STATUS.ACTIVE
}

export const needsSetup = (connection) => Boolean(connection.instances && connection.instances[0] && !connection.instances[0].isSetupCompleted)

export const summarizeConnections = (connections) => ({
    total: connections.length,
    active: connections.filter((item) => connectionStatus(item) === CONNECTION_STATUS.ACTIVE).length,
    expiring: connections.filter((item) => connectionStatus(item) === CONNECTION_STATUS.EXPIRING).length,
    expired: connections.filter((item) => connectionStatus(item) === CONNECTION_STATUS.EXPIRED).length,
    needsSetup: connections.filter(needsSetup).length
})
